import React, { Component } from 'react';
import Footer from './Footer';
import Nav from './Nav';
import Ebook from './Ebook';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
const cookiesMinutesToExpire = 60; // tempo em minutos para a expiração dos cookis

// if (window.location.pathname === '/') {
//   window.location.replace('/material-estudos/cpa10/sistema-financeiro-nacional-e-participantes-do-mercado');
// }
class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubscribed: cookies.get('isSubscribed'),
      name: cookies.get('name'),
      email: cookies.get('email'),
      cpfcnpj: {
        value: cookies.get('cpfcnpj') || '',
        validCpf: false,
        validCnpj: false
      },
      cpf: cookies.get('cpf'),
      cnpj: cookies.get('cnpj')
    };
  }

  componentDidMount() {
    const _cpfcnpj = Object.assign({}, this.state.cpfcnpj);
    _cpfcnpj.validCpf = this._validaCPF(_cpfcnpj.value) || this._validaCNPJ(_cpfcnpj.value);
    _cpfcnpj.validCnpj = this._validaCPF(_cpfcnpj.value) || this._validaCNPJ(_cpfcnpj.value);

    this.setState({ cpfcnpj: _cpfcnpj });
  }

  setSubscribed = isSubscribed => {
    let cookiesExpirationTime = new Date();
    cookiesExpirationTime.setTime(
      cookiesExpirationTime.getTime() + cookiesMinutesToExpire * 60 * 1000
    );

    cookies.set('isSubscribed', false, { path: '/', expires: cookiesExpirationTime });
    this.setState({ isSubscribed: isSubscribed });
  };

  handleName = name => {
    let cookiesExpirationTime = new Date();
    cookiesExpirationTime.setTime(
      cookiesExpirationTime.getTime() + cookiesMinutesToExpire * 60 * 1000
    );

    cookies.set('name', name, { path: '/', expires: cookiesExpirationTime });
    this.setState({ name: name });
  };

  handleEmail = email => {
    let cookiesExpirationTime = new Date();
    cookiesExpirationTime.setTime(
      cookiesExpirationTime.getTime() + cookiesMinutesToExpire * 60 * 1000
    );

    cookies.set('email', email, { path: '/', expires: cookiesExpirationTime });
    this.setState({ email: email });
  };

  handleCpfcnpj = value => {
    const _cpfcnpj = Object.assign({}, this.state.cpfcnpj);

    let cookiesExpirationTime = new Date();
    cookiesExpirationTime.setTime(
      cookiesExpirationTime.getTime() + cookiesMinutesToExpire * 60 * 1000
    );

    cookies.set('cpfcnpj', value, { path: '/', expires: cookiesExpirationTime });
    switch (value.length) {
      case 0:
        break;
      case 11:
        _cpfcnpj.validCpf = this._validaCPF(value);
        break;
      case 14:
        _cpfcnpj.validCnpj = this._validaCNPJ(value);
        break;
      default:
        _cpfcnpj.validCpf = false;
        _cpfcnpj.validCnpj = false;
    }

    _cpfcnpj.value = value;

    this.setState({ cpfcnpj: _cpfcnpj });
  };

  // Valida CPF
  _validaCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf === '') return false;
    if (
      cpf.length !== 11 ||
      cpf === '00000000000' ||
      cpf === '11111111111' ||
      cpf === '22222222222' ||
      cpf === '33333333333' ||
      cpf === '44444444444' ||
      cpf === '55555555555' ||
      cpf === '66666666666' ||
      cpf === '77777777777' ||
      cpf === '88888888888' ||
      cpf === '99999999999' ||
      cpf === '01234567890'
    )
      return false;
    let add = 0;
    for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i), 10) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev === 10 || rev === 11) rev = 0;
    if (rev !== parseInt(cpf.charAt(9), 10)) return false;
    add = 0;
    for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i), 10) * (11 - i);
    rev = 11 - (add % 11);
    if (rev === 10 || rev === 11) rev = 0;
    if (rev !== parseInt(cpf.charAt(10), 10)) return false;
    return true;
  }

  // Valida CNPJ
  _validaCNPJ(CNPJ) {
    CNPJ = CNPJ.replace(/[^\d]+/g, '');
    let a = [],
      b;
    var c = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    for (let i = 0; i < 12; i++) {
      a[i] = CNPJ.charAt(i);
      b += a[i] * c[i + 1];
    }
    let x = b % 11;
    if (x < 2) {
      a[12] = 0;
    } else {
      a[12] = 11 - x;
    }
    b = 0;
    for (let y = 0; y < 13; y++) {
      b += a[y] * c[y];
    }
    x = b % 11;
    if (x < 2) {
      a[13] = 0;
    } else {
      a[13] = 11 - x;
    }
    if (CNPJ.charAt(12) !== a[12] || CNPJ.charAt(13) !== a[13]) {
      return false;
    }
    if (CNPJ === '00000000000000') {
      return false;
    }
    return true;
  }

  handleCpf = cpf => {
    let cookiesExpirationTime = new Date();
    cookiesExpirationTime.setTime(
      cookiesExpirationTime.getTime() + cookiesMinutesToExpire * 60 * 1000
    );

    cookies.set('cpf', cpf, { path: '/', expires: cookiesExpirationTime });
    this.setState({ cpf: cpf });
  };

  handleCnpj = cnpj => {
    let cookiesExpirationTime = new Date();
    cookiesExpirationTime.setTime(
      cookiesExpirationTime.getTime() + cookiesMinutesToExpire * 60 * 1000
    );

    cookies.set('cnpj', cnpj, { path: '/', expires: cookiesExpirationTime });
    this.setState({ cnpj: cnpj });
  };

  render() {
    const { isSubscribed, name, email, cpfcnpj, cpf, cnpj } = this.state;
    const pathsRoute = [
      '/sistema-financeiro',
      '/analise-do-perfil-investidor',
      '/conceitos-basicos-economia-financas',
      '/principios-de-investimento',
      '/fundos-de-investimento',
      '/renda-variavel-fixa',
      '/previdencia'
    ];
    return (
      <Router basename="/material-estudos/cpa10">
        <div>
          <Nav />
          <Route exact path="/" render={() => <Redirect to="/sistema-financeiro" />} />
          {pathsRoute.map(path => (
            <PropsRoute
              key={path}
              path={path}
              component={Ebook}
              setSubscribed={this.setSubscribed}
              isSubscribed={isSubscribed}
              handleName={this.handleName}
              name={name}
              handleEmail={this.handleEmail}
              email={email}
              handleCpfcnpj={this.handleCpfcnpj}
              cpfcnpj={cpfcnpj}
              handleCpf={this.handleCpf}
              cpf={cpf}
              handleCnpj={this.handleCnpj}
              cnpj={cnpj}
            />
          ))}
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;

const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return React.createElement(component, finalProps);
};

const PropsRoute = ({ component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={routeProps => {
        return renderMergedProps(component, routeProps, rest);
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/App.js